module.exports = __webpack_public_path__ + "static/media/logo2.1671a513.png";